export default "__VITE_ASSET__Caemf5qC__"